<template>
  <div>
    <q-dialog v-model="modalIsOpen" :content-css="{minWidth: '50vw', minHeight: '20vh'}">
      <q-card class="bg-white">
        <q-card-section horizontal>
          <span class="q-toolbar-title">
            {{fullName.length > 0 ? fullName : $t('student.newstudent.studentmodal')}}
          </span>
          <q-btn class="pull-right" flat @click="modalIsOpen = false">
            <q-icon name="close"/>
          </q-btn>
        </q-card-section>

      </q-card>
      <div class="modal-body">
      </div>
    </q-dialog>
  </div>
</template>

<script>
  import { QBtn, QCard, QDialog, QIcon } from 'quasar'

  export default {
    components: {
      QDialog,
      QBtn,
      QIcon,
      QCard
    },
    props: {
      student: Object,
      possibleGroups: Array
    },
    computed: {
      fullName () {
        return `${this.student.firstname || ''} ${this.student.middlename || ''} ${this.student.lastname || ''}`.trim()
      }
    },
    methods: {
      open () {
        this.modalIsOpen = true
      }
    },
    data () {
      return {
        modalIsOpen: false,
        loading: false
      }
    }
  }
</script>

<style>
  .modal-footer {
    box-shadow: none;
  }
</style>
